<template>
    <div class="chart-panel" />
  </template>
  
  <style>
      .chart-panel {
          background-color: #fff;
          opacity: 0.85;
          position: absolute;
          top: 1px;
      }
  </style>
  